import type { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import type { ImageSources } from '@dinewise/utils/node';
import { $path } from 'safe-routes';
import type { SessionUser } from '~/utils/sessions.server.ts';
import { PaymentsFloatingNav } from './payments-floating-nav/payments-floating-nav.tsx';
import { PaymentsWelcomeHeader } from './payments-welcome-header.tsx';

type PaymentsAppShellProps = PropsWithChildren<{
  user: SessionUser;
  avatarImageSources?: ImageSources | null;
}>;

export const PaymentsAppShell = ({ children, user, avatarImageSources }: PaymentsAppShellProps) => {
  const location = useLocation();
  const showWelcomeHeader =
    location.pathname !== $path('/profile') && location.pathname !== $path('/paylink/new');

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-white">
      {showWelcomeHeader ? (
        <PaymentsWelcomeHeader user={user} avatarImageSources={avatarImageSources} />
      ) : null}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden pb-20">{children}</div>
      <PaymentsFloatingNav />
    </div>
  );
};
